import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative h-screen bg-gradient-to-r from-secondary-900 via-secondary-800 to-secondary-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-black opacity-40"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')] opacity-10 bg-cover bg-center"></div>
      <div className="container relative flex flex-col items-center justify-center h-full text-center z-10">
        <motion.h1
          className="mb-6 font-bold text-shadow-lg letter-spacing-tight"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, type: "spring", damping: 12 }}
        >
          Transforming Ideas into <br />
          <motion.span
            className="gradient-text inline-block"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.3, type: "spring" }}
          >
            Innovative Solutions
          </motion.span>
        </motion.h1>

        <motion.p
          className="max-w-2xl mb-8 text-lg text-secondary-200 text-balance"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          FutureSoft Technologies specializes in creating cutting-edge software solutions
          that drive business growth and enhance user experiences.
        </motion.p>

        <motion.div
          className="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4, type: "spring", stiffness: 100 }}
        >
          <motion.div
            whileHover={{
              scale: 1.03,
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
            }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <Link to="/services" className="btn btn-primary">
              Explore Our Services
            </Link>
          </motion.div>
          <motion.div
            whileHover={{
              scale: 1.03,
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
            }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <Link to="/contact" className="btn btn-secondary">
              Get in Touch
            </Link>
          </motion.div>
        </motion.div>
      </div>

      <motion.div
        className="absolute bottom-0 left-0 right-0 flex justify-center pb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.8 }}
      >
        <motion.a
          href="#services"
          className="flex items-center justify-center w-10 h-10 text-white bg-primary-600 rounded-full shadow-md"
          aria-label="Scroll down"
          whileHover={{
            scale: 1.1,
            backgroundColor: '#0ea5e9',
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.2)"
          }}
          whileTap={{ scale: 0.9 }}
          animate={{
            y: [0, 10, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            repeatType: "loop",
            ease: "easeInOut"
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </motion.a>
      </motion.div>
    </section>
  );
};

export default Hero;
